import { useAppSelector } from "redux-share";
import { conditions } from "../../../../../helpers";
import { ConditionName, IMultiLiveIconProps } from "../../../../../interfaces";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const MultiLivesIcon = dynamic(() => import("../../icon-components/multiLiveIcon"));

const MultiLiveIcon = (props: IMultiLiveIconProps) => {

    useAppSelector(({ videoData: { isComplexPortrait } }) => ({ isComplexPortrait }), shallowEqual);

    let icon = <></>;

    if (conditions(ConditionName.isSplusEnvironment)) icon = <i className={`fa-solid fa-camera-rotate pl-cursor-pointer ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"}}`} {...props} />
    else icon = <div className="pl-cursor-pointer" {...props}><MultiLivesIcon className={`${conditions(ConditionName.isComplexPortrait) ? "pl-w-[16px] pl-h-[16px] pl-fill-gray-800 dark:pl-fill-dark-5" : `pl-fill-dark-5 ${conditions(ConditionName.isFullMobilePortrait) ? "pl-w-[13px] pl-h-[13px]" : "pl-w-[22px] pl-h-[22px]"}`}`} strokeColor={!conditions(ConditionName.isComplexPortrait) ? "black" : ""} /></div>

    if(conditions(ConditionName.isComplexPortrait)) icon = (
        <div className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer" onClick={props.onClick}>
            {icon}
            <span className="pl-whitespace-nowrap">چند دوربینی</span>
        </div>
    )

    return <>{icon}</>
}

export default MultiLiveIcon;